import { removeEmptyNullAndUndefinedFromObject, withLatestLocation } from "../../utils/common";

/**
 * Generates the URI for adding an item to the cart.
 *
 * @returns {string} The URI to add an item to the cart.
 */
export const ADD_TO_CART_URI = () => {
  return `/control/additem-rj`;
};

/**
 * Generates the URI for viewing the cart.
 *
 * @param {Object} params
 * @param {string} [params.lite="N"]
 * @param {number|string} [params.lat]
 * @param {number|string} [params.long]
 * @param {boolean} [params.isFromCheckout=false] - Whether the cart is being viewed from the checkout page.
 * @returns {string} The URI to view the cart.
 */
export const GET_CART_URI = ({ lite = "N", lat, long } = {}) => {
  const query = new URLSearchParams(
    removeEmptyNullAndUndefinedFromObject(withLatestLocation({ lite, lat, long })),
  ).toString();

  return `/serviceability/v1/complete/cart-items?${query}`;
};

/**
 * Generates the URI for deleting an item from the cart.
 *
 * @returns {string} The URI to delete an item from the cart.
 */
export const DELETE_CART_URI = () => {
  return `/control/deleteItem-rj`;
};

/**
 * Generates the URI for setting cart item values.
 *
 * @returns {string} The URI to set cart item values.
 */
export const SET_CART_ITEM_URI = () => {
  return `/control/setCartItemValues-rj`;
};

/**
 * Generates the URI for logging out.
 *
 * @returns {string} The URI to log out and redirect to the specified location.
 */
export const LOG_OUT = () => {
  return `/control/logout?to=/`;
};

/**
 * Generates the URI for logging out.
 *
 * @returns {string} The URI to log out and redirect to the specified location.
 */
export const UPDATE_ADD_ON_QUANTITY = () => {
  return `/control/updateAddonQuantityProduct-rj`;
};

/**
 * Generates the URI for updating base product quantity on checkout.
 *
 * @returns {string} The URI to update base product quantity.
 */
export const UPDATE_BASE_PRODUCT_QUANTITY = () => {
  return `/control/updateBaseProductQuantity`;
};

/**
 * Generates the URI for viewing the cart.
 *
 * @returns {string} The URI to view the cart, with external access enabled.
 */
export const GET_PERSONALIZATION_DETAILS = (orderItemSeqId) => {
  return `/control/getPerOptForItem?orderItemSeqId=${orderItemSeqId}`;
};

/**
 * Generates the URI for setting the FNP wallet selection.
 *
 * @returns {string} The URI to set the FNP wallet selection.
 */
export const SET_FNP_WALLET_SELECTION = () => {
  return `/control/setFnpCashSelection-rj`;
};
